import React from "react";
import { FormattedMessage } from "react-intl";

import { Dropdown } from "../../../../components/dropdown/Dropdown";
import { ClickAbsorber } from "../../../../components/clickAbsorber/ClickAbsorber";
import { Icon } from "../../../../components/icon/Icon";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";

import "./ProfileTab.scss";

export const ProfileTabDropdown = ({ menu, profileName }) => {
  return (
    <ClickAbsorber className="profile-tab-dropdown">
      <Dropdown
        toggleButton={
          <UnstyledButton className="profile-tab__toggle-actions">
            <Icon icon="fa-solid fa-ellipsis-v" />
          </UnstyledButton>
        }
        items={menu}
        hiddenLabel={
          <FormattedMessage
            id="profile_actions_menu_label"
            values={{ profileName }}
          />
        }
        popperOptions={{ strategy: "absolute" }}
      />
    </ClickAbsorber>
  );
};

// Keep it synced with scss
export const PROFILE_TAB_ACTIVE_CLASS = "profile-tab--active";

export const ProfileTabContent = ({
  type = "custom",
  title: profileName,
  description = null,
}) => {
  return (
    <div className="profile-tab-content">
      <div className="profile-tab-content__title">
        {type !== "custom" ? (
          <FormattedMessage id={profileName} defaultMessage={profileName} />
        ) : (
          profileName
        )}
      </div>
      <div className="profile-tab-content__description">
        {React.isValidElement(description) ? (
          description
        ) : (
          <FormattedMessage id={`${type}_description`} defaultMessage={""} />
        )}
      </div>
    </div>
  );
};
